var UserApiKeyAuthProvider = function () {
  function UserApiKeyAuthProvider() {}

  UserApiKeyAuthProvider.TYPE = "api-key";
  UserApiKeyAuthProvider.DEFAULT_NAME = "api-key";
  return UserApiKeyAuthProvider;
}();

export default UserApiKeyAuthProvider;